class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.accordion-btn');
    
    this.buttons.forEach(btn => {
      btn.addEventListener('click', this.toggle.bind(this));
    });

    // Optional: Open the first item by default on load
    if(this.buttons.length > 0 && this.dataset.openFirst === "true") {
      this.openItem(this.buttons[0]);
    }
  }

  toggle(e) {
    const btn = e.currentTarget;
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';

    // Close all other items (Standard Accordion Behavior)
    this.buttons.forEach(b => {
      if (b !== btn) this.closeItem(b);
    });

    if (isExpanded) {
      this.closeItem(btn);
    } else {
      this.openItem(btn);
    }
  }

  openItem(btn) {
    btn.setAttribute('aria-expanded', 'true');
    const content = btn.nextElementSibling;
    content.style.maxHeight = content.scrollHeight + "px";
  }

  closeItem(btn) {
    btn.setAttribute('aria-expanded', 'false');
    const content = btn.nextElementSibling;
    content.style.maxHeight = null;
  }
}

if (!customElements.get('custom-accordion')) {
  customElements.define('custom-accordion', CustomAccordion);
}